import { render, staticRenderFns } from "./FirstTypeSelect.vue?vue&type=template&id=b2b9661a&scoped=true&"
import script from "./FirstTypeSelect.vue?vue&type=script&lang=js&"
export * from "./FirstTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./FirstTypeSelect.vue?vue&type=style&index=0&id=b2b9661a&prod&lang=scss&"
import style1 from "./FirstTypeSelect.vue?vue&type=style&index=1&id=b2b9661a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b9661a",
  null
  
)

export default component.exports